import { render, staticRenderFns } from "./BreakRules.vue?vue&type=template&id=6d9e4e20&scoped=true"
import script from "./BreakRules.vue?vue&type=script&lang=js"
export * from "./BreakRules.vue?vue&type=script&lang=js"
import style0 from "./BreakRules.vue?vue&type=style&index=0&id=6d9e4e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9e4e20",
  null
  
)

export default component.exports